import React, { useState } from "react";
import "./Cart.css";

let user = JSON.parse(localStorage.getItem("user"));

export default function Basket(props) {
  const { cartItems, onAdd, onRemove } = props;
  const itemsPrice = cartItems.reduce((a, c) => a + c.qty * c.price, 0);
  // const taxPrice = itemsPrice * 0.14;
  // const shippingPrice = itemsPrice > 2000 ? 0 : 20;
  const totalPrice = itemsPrice;

  // const [sale, setSale] = useState("");

  console.log(cartItems);

  async function sales() {
    let item = {
      username: user.user.name,
      image: user.user.image,
      email: user.user.email,
      phone: user.user.phone,
      products: JSON.stringify(cartItems),
      amount: totalPrice.toFixed(2),
    };

    let result = await fetch("http://localhost:5000/api/v1/sales", {
      method: "POST",
      body: JSON.stringify(item),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    result = await result.json();
  }
  function salesHandler(e) {
    e.preventDefault();
  }

  return (
    <aside
      className="block col-1"
      style={{
        margin: "10px",
        backgroundColor: "#e9e9ed",
        padding: "10px",
        marginTop: "0px",
      }}
    >
      <div>
        {cartItems.length === 0 && (
          <div style={{ textAlign: "center", fontWeight: 600 }}>
            Cart is empty
          </div>
        )}
        {cartItems.map((item) => (
          <div key={item.id} className="row">
            <div className="col-2">{item.name}</div>
            <div className="col-2">
              <button onClick={() => onRemove(item)} className="remove">
                -
              </button>{" "}
              <button onClick={() => onAdd(item)} className="add">
                +
              </button>
            </div>

            <div className="col-2 text-right">
              {item.qty} x {item.price.toFixed(2)}
            </div>
          </div>
        ))}

        {cartItems.length !== 0 && (
          <>
            <hr></hr>
            <div className="row">
              <div className="col-2">Items Price</div>
              <div className="col-1 text-right">{itemsPrice.toFixed(2)}</div>
            </div>
            {/* <div className="row">
              <div className="col-2">Tax Price</div>
              <div className="col-1 text-right"> {taxPrice.toFixed(2)}</div>
            </div> */}
            {/* <div className="row">
              <div className="col-2">Shipping Price</div>
              <div className="col-1 text-right">{shippingPrice.toFixed(2)}</div>
            </div> */}

            <div className="row">
              <div className="col-2">
                <strong>Total Price</strong>
              </div>
              <div className="col-1 text-right">
                <strong> {totalPrice.toFixed(2)}</strong>
              </div>
            </div>
            <hr />

            <div className="payment">
              <form
                onSubmit={salesHandler}
                // method="POST"
                // action="https://checkout.flutterwave.com/v3/hosted/pay"
              >
                <input
                  type="hidden"
                  name="public_key"
                  value="FLWPUBK-98c8f0137ff339b8cb47b5c98cbe4a33-X"
                />
                <input
                  type="hidden"
                  name="customer[email]"
                  value="jessepinkman@walterwhite.org"
                />
                <input
                  type="hidden"
                  name="customer[name]"
                  value="Jesse Pinkman"
                />
                <input type="hidden" name="tx_ref" value="bitethtx-019203" />
                <input
                  type="hidden"
                  name="amount"
                  value={totalPrice.toFixed(2)}
                />
                <input type="hidden" name="currency" value="UGX" />
                <input type="hidden" name="meta[token]" value="54" />
                <input
                  type="hidden"
                  name="redirect_url"
                  value="http://localhost:3000/"
                />
                <button className="checkout" type="submit" onClick={sales}>
                  Pay Now
                </button>
              </form>
            </div>
          </>
        )}
      </div>
    </aside>
  );
}
